export class UrlDescargaApp {

	IdApp: string;
	Tipo: string;
	Url_android: string;
	Url_ios: string;

	constructor(urlDescarga?) {

		if (urlDescarga) {
			this.IdApp = urlDescarga.IdApp;
			this.Tipo = urlDescarga.Tipo;
			this.Url_android = urlDescarga.Url_android;
			this.Url_ios = urlDescarga.Url_ios;
		}

	}
}


export class AlaIdiomaFormulario {

	Codigo: string;
	Nombre: string;
	Descripcion: string;

	constructor(alaIdioma?) {

		if (alaIdioma) {
			this.Codigo = alaIdioma.IDIOMA.Codigo ? alaIdioma.IDIOMA.Codigo : '';
			this.Nombre =  alaIdioma.Nombre ? alaIdioma.Nombre : '';
			this.Descripcion = alaIdioma.Descripcion ? alaIdioma.Descripcion : '';
		}
		else{
			this.Codigo = '';
			this.Nombre = '';
			this.Descripcion = '';
		}

	 }
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/UrlDescargaApp.ts